const transformConsent = ({ results } = {}) => {
  return results?.[0] ?? {};
};

export default transformConsent;
